import { createRoutine } from "@rentiohq/shared-frontend/dist/redux/utils/routine.utils";
export var getStats = createRoutine("STATS_GET");
